export default "__VITE_ASSET__PLfy_msl__"